import { useEffect } from "react";
import { saveAs } from "file-saver";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import Base64ToBlob from "../../../../components/Formatters/Base64ToBlob";

const useDocumentoProrrogacao = () => {
  const { request: requestDocumento, data: dataDocumento } = useApiClient();

  const showDocumento = (documento, nomeArquivo, salvar) => {
    let byteArray = documento;

    if (typeof byteArray === "string") {
      byteArray = Base64ToBlob(documento);
    }

    if (nomeArquivo) {
      const tipoArquivo = nomeArquivo.split(".").pop();

      if (tipoArquivo !== "pdf" || salvar) {
        const file = new Blob([byteArray], { type: `application/${tipoArquivo}` });
        saveAs(file, nomeArquivo);
      } else {
        const file = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(file);
        window.open(url, "", "width=800,height=800");
      }
    } else {
      const file = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
  };

  const buscaDocumento = (sqOrdemServico, sqPedidoProrrogacao, sqAndamento) => {
    const values = {
      SqOrdemServico: sqOrdemServico,
      SqPedidoProrrogacao: sqPedidoProrrogacao,
      SqAndamento: sqAndamento,
    };
    console.log("values: ", values);
    requestDocumento(apiRoutes.fiscalizacao.prorrogacaoos.documentoAtividade, values);
  };

  useEffect(() => {
    if (dataDocumento) {
      showDocumento(dataDocumento);
    }
  }, [dataDocumento]);

  return { buscaDocumento };
};

export default useDocumentoProrrogacao;
